<template>
  <li>
    <div class='block-small-media live-video-container'>
      <div v-if='isCanceled' class='live-video-meta rec active'>{{textCanceled}}</div>
      <div v-else class='live-video-ended'>
        <span>{{videoTempText}}</span>
      </div>
      <img :src='item.fallback' :alt='item.altText' :title='item.altText' />
    </div>
    <slider-item-information :item='item'></slider-item-information>
  </li>
</template>

<script>
import consts from '../../consts'
import mixins from '../../mixins'
import lang from '../../lang'
import SliderItemInformation from './SliderItemInformation'

export default {
  mixins: [mixins],
  name: 'slider-item',
  data () {
    return {
      textCanceled: lang.canceled[this.$root.cmsData.lang],
      videoTempText: this.item.isHearing ? this.$root.cmsData.mainBlock.tempTextHearing : this.$root.cmsData.mainBlock.tempTextStorting
    }
  },
  computed: {
    isCanceled: function () {
      return this.item.status === consts.status.canceled
    }
  },
  components: {
    SliderItemInformation
  },
  props: ['item']
}
</script>



// WEBPACK FOOTER //
// SliderItem.vue?4e0730a1